import React, { useEffect, useState, useRef } from 'react';
import { Card, Table } from 'react-bootstrap';
import logoImage from '../assets/images/logo.png';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner'; // Importing ProgressSpinner
import axios from 'axios';
import config from '../config';
import { useAuth } from '../context/AuthContext';

import stampImage from '../assets/images/stamp.png';
import watermarkImage from '../assets/images/Graphe_Letterhead_watermark.jpg';


const Download_Letter = ({ letter }) => {
    const { accessToken, userId } = useAuth();
    const [loading, setLoading] = useState(false); // State to track loading status
    const downloadPDF = async () => {
        setLoading(true);

        try {
            const response = await axios.post(
                `${config.apiBASEURL}/letterRoutes/letters/${letter.send_letter_id}/pdf`,
                { user_id: userId },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.data?.pdfUrl) {
                window.open(response.data.pdfUrl, "_blank"); // Open PDF in a new tab
            } else {
                console.error("PDF URL not found in response");
            }
        } catch (error) {
            console.error("Error generating PDF:", error);
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className='watermark'>
            <div className="letterContent letterTable">
                <div className="letterHeader slslip_card text-left" style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between' }}>
                    <img src={logoImage} alt="brand-logo" style={{ width: '120px', height: '120px', objectFit: 'contain', margin: '0px' }} />
                    <div style={{ width: '200px' }}>
                        <p className='text-black'>
                            <small className="mb-4" style={{ fontWeight: '400', textDecoration: 'none', textAlign: 'left' }}>
                                1105, Godrej Genesis,<br /> Sector 5, Salt Lake City,<br /> Kolkata 700091
                                <br />
                                connect@thegraphe.com
                                <br />
                                +91 7727827092
                            </small>
                        </p>
                        {/* <span className="mt-2 d-block text-muted">
                            Update by: {letter.creator_name || 'N/A'} | Last Updated: {new Date(letter.updatedAt).toLocaleDateString('en-GB')}
                        </span> */}
                    </div>
                </div>
                <div className="letterBody" style={{ marginTop: '80px', display: 'block' }}>
                    <p style={{ color: '#000', marginBottom: '30px' }}>
                        <strong>To:</strong> <br />{letter.employee_name || 'N/A'}
                        <span style={{ display: 'block' }}>
                            <span>Date:</span> {new Date(letter.updatedAt).toLocaleDateString('en-GB')}
                        </span>
                    </p>

                    {letter.send_letter_sections && letter.send_letter_sections.length > 0 ? (
                        letter.send_letter_sections
                            .sort((a, b) => a.section_order - b.section_order)
                            .map((section) => (
                                <span key={section.section_id}>
                                    {section.section_heading && (
                                        <strong>
                                            {section.section_heading}
                                        </strong>
                                    )}
                                    {section.section_body && (
                                        <span
                                            dangerouslySetInnerHTML={{ __html: section.section_body }}
                                        />
                                    )}
                                </span>
                            ))
                    ) : (
                        <p>No sections available.</p>
                    )}

                    <div>
                        <p style={{ fontSize: '15px', color: '#000' }}>Thanking you,</p>
                        {letter.signature_url ? (
                            <img src={letter.signature_url} alt="Signature" style={{ width: '180px', height: 'auto' }} />

                        ) : (
                            <p>No signature available</p>
                        )}
                        <img src={stampImage} alt="brand-logo" style={{ width: '70px', height: '70px', objectFit: 'contain', marginLeft: '40px' }} />
                        <p style={{ fontSize: '15px', color: '#000' }}>{letter.creator_name || 'N/A'} <br />{letter.creator_designation || 'N/A'}</p>
                    </div>


                </div>
                <div className="letterFooter">
                    <div className="footer" style={{ textAlign: 'center', marginTop: '40px' }}>
                        <small>193/1 2nd Floor, Mahatma Gandhi Road, Kolkata - 700007, India | GSTIN: 19CRHPM0854N1Z7</small>
                    </div>
                </div>

            </div>

            {/* Loader displayed while generating PDF */}
            {loading ? (
                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <ProgressSpinner />
                </div>
            ) : (
                // <Button label="Download Letter as PDF" icon="pi pi-download" onClick={downloadPDF} />
                <Button
                    label="Download PDF"
                    onClick={downloadPDF}
                    className="py-2 d-none"
                    severity='warning'
                    icon="pi pi-download"
                    style={{ position: 'absolute', top: '1.5rem', left: '1.5rem' }}
                />
            )}
        </div>
    );
};

export default Download_Letter;